import * as React from "react";

import type {Props} from "./props.ts";
import ShowOnceDismissible from "./show-once-dismissible.tsx";
import StandardDismissible from "./standard-dismissible.tsx";

export default function Dismissible(props: Props): React.ReactElement {
    const {showOnce, ...restProps} = props;
    return showOnce ? (
        <ShowOnceDismissible {...restProps} />
    ) : (
        <StandardDismissible {...restProps} />
    );
}
